import * as React from "react";
import type { GatsbyBrowser, WrapPageElementBrowserArgs } from "gatsby";

import "./src/styles/global.css";
import { trackPageView } from "./src/lib/analytics";
import { CookieConsentManager } from "./src/components/layout/cookie-consent-manager";

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({
  element,
}: WrapPageElementBrowserArgs) => (
  <>
    {element}
    <CookieConsentManager />
  </>
);

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = ({ location }) => {
  trackPageView(location.pathname + location.search + location.hash);
};
